export const STATICS = {
  LINKED_URL: "https://www.linkedin.com/in/mehulsinghteya",
  GITHUB_URL: "https://www.github.com/daxter-army",
  GITHUB_REPO_URL: "https://www.github.com/daxter-army/daxter-army.github.io",
  ICON_URL: "https://daxter-army.github.io/daxUI/static/media/m.e08629e9.svg",
  INTRO: "Hello!, I am a Software Engineer, working as a Professional in India",
  NAME: "Mehul Singh Teya",
  BIO: "Craftsman (Developer/Artist)",
  GITHUB_AVATAAR_URL: "https://avatars.githubusercontent.com/u/49727032?v=4",
  GITHUB_HANDLE: "@daxter-army",
  LINKEDIN_HANDLE: "@mehulsinghteya",
  HOBBIES_DESC:
    "I like Art, Music, Video Games, Sudoku, Photography, playing Musical Keyboard, Machine Learning, Raspberry Pi",
  BIO_DESC:
    "Mehul Singh Teya, is a Software Engineer with passion of building stuffs and services he likes. He likes to build projects, that not only can help others, but also eases his own daily life. When not online, he likes to play minesweeper, solve Sudoku and play musical keyboard.",
  PRESENT_SITUATION: "Currently, he is working as SDE in India.",
  THAPAR_URL: "https://www.thapar.edu/",
  WORKS: "My projects",
  FOOTER_TEXT: "Mehul Singh Teya. All Rights Reserved",
  AUTHOR_NAME: "Mehul Singh Teya",
  LIGHT_THEME_MODE: "light",
  DARK_THEME_MODE: "dark",
  WEB_MCP: {
    PROFILE_TOOL: {
      NAME: "get_portfolio_profile",
      TITLE: "Get portfolio profile",
      DESCRIPTION:
        "Return Mehul Singh Teya's professional summary, technical skills, and public profile links.",
    },
    PROJECT_SEARCH_TOOL: {
      NAME: "search_projects",
      TITLE: "Search portfolio projects",
      DESCRIPTION:
        "Find Mehul Singh Teya's projects by name, technology, or description. Returns project descriptions and public URLs.",
      QUERY_DESCRIPTION:
        'A name or technology such as "React", "WebAssembly", or "Sudoku". Leave empty to return every project.',
    },
    REGISTRATION_ERROR: "Unable to register WebMCP tools",
  },
};
